import React from 'react';
import { motion } from 'framer-motion';
import { Clock } from 'lucide-react';
export function RecipesPreview() {
  const recipes = [{
    title: 'Bowl Antiinflamatorio Matutino',
    type: 'Desayuno',
    time: '10 min',
    image: 'https://images.unsplash.com/photo-1490645935967-10de6ba17061?w=800'
  }, {
    title: 'Salmón Express con Verduras',
    type: 'Almuerzo',
    time: '20 min',
    image: 'https://images.unsplash.com/photo-1467003909585-2f8a72700288?w=800'
  }, {
    title: 'Crema de Calabaza con Jengibre',
    type: 'Cena',
    time: '25 min',
    image: 'https://images.unsplash.com/photo-1476718406336-bb5a9690ee2a?w=800&q=80'
  }, {
    title: 'Smoothie Verde Detox',
    type: 'Desayuno',
    time: '5 min',
    image: 'https://images.unsplash.com/photo-1610970881699-44a5587cabec?w=800'
  }, {
    title: 'Golden Milk',
    type: 'Bebida',
    time: '5 min',
    image: 'https://cdn.magicpatterns.com/uploads/xyUXsv8m9rUVfc2MEjBahN/ChatGPT_Image_21_may_2026,_06_42_50_p.m..png'
  }, {
    title: 'Bowl Mediterráneo',
    type: 'Almuerzo',
    time: '15 min',
    image: 'https://images.unsplash.com/photo-1512621776951-a57141f2eefd?w=800'
  }];
  return <section className="w-full px-4 py-20 bg-cream" data-id="element-274">
      <div className="max-w-6xl mx-auto" data-id="element-275">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-276">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif text-ink mb-6" data-id="element-277">
            Así de práctico, rico y claro se ve tu camino antiinflamatorio
          </h2>
          <p className="text-lg md:text-xl text-ink/80 max-w-2xl mx-auto" data-id="element-278">
            Una muestra de las 15 recetas rápidas que encontrarás dentro de la
            guía.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-279">
          {recipes.map((recipe, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="group bg-ivory rounded-2xl overflow-hidden shadow-sm hover:shadow-md transition-all duration-300" data-id="element-280">
              <div className="relative aspect-[4/3] overflow-hidden" data-id="element-281">
                <img src={recipe.image} alt={recipe.title} className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700" data-id="element-282" />
                <div className="absolute top-4 left-4 bg-ivory/90 backdrop-blur-sm px-3 py-1 rounded-full text-xs font-bold tracking-wider text-taupe uppercase" data-id="element-283">
                  {recipe.type}
                </div>
              </div>
              <div className="p-6" data-id="element-284">
                <h3 className="text-xl font-serif font-bold text-ink mb-3 line-clamp-2" data-id="element-285">
                  {recipe.title}
                </h3>
                <div className="flex items-center gap-2 text-sm text-muted font-medium" data-id="element-286">
                  <Clock className="w-4 h-4" data-id="element-287" />
                  <span data-id="element-288">{recipe.time}</span>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}